var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { TableViewData } from "./TableViewData";
import { useCallback, useContext, useEffect, useMemo, useState } from "react";
import { useAsync2 } from "nate-react-api-helpers";
import { blankArray, pageSize } from "./TableViewSimple";
import { TableContext } from "./TableProvider";
import { encodeFilter } from "./TableFilter";
import { valueToString } from "./editable/ValueCell";
import { jsx as _jsx } from "react/jsx-runtime";
function columnsAreEditable(cols, editable) { return editable; }
function isSubCols(cols) { if (cols.length === 0)
    return false; return cols.filter(function (c) { return "key" in c; }).length > 0; }
function convertOrderByToColumnName(name, columns) { var matches = columns.filter(function (c) { return c.name === name; }); if (matches.length === 1) {
    var key = matches[0].key;
    if (key !== undefined)
        return key.toString();
} return name; }
export function TableViewDataSimple(props) {
    var _this = this;
    var _list$result, _list$result2;
    var parentId = props.parentId;
    var search = props.search;
    var filter = props.filter;
    var _a = useState(0), page = _a[0], setPage = _a[1];
    var _b = useState(props.orderByColumnName || props.cols[0].name), orderBy = _b[0], setOrderBy = _b[1];
    var _c = useState(props.orderByDirection || "asc"), orderByDirection = _c[0], setOrderByDirection = _c[1];
    var orderByChange = useCallback(function (col, direction) { setOrderBy(col); setOrderByDirection(direction); }, []);
    var _d = useState([]), inserted = _d[0], setInserted = _d[1];
    var list = useAsync2(function (opts) { return __awaiter(_this, void 0, void 0, function () { var result; return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, props.fetcher(opts)];
            case 1:
                result = _a.sent();
                setInserted([]);
                return [2 /*return*/, result];
        }
    }); }); }, { page: page, search: search, orderBy: props.editable ? convertOrderByToColumnName(orderBy, props.cols) : orderBy, filter: encodeFilter(filter), orderByDirection: orderByDirection, parentId: parentId, pageSize: props.noPaginate ? 1e6 : pageSize }, [page, filter, search, orderBy, orderByDirection, parentId, props.noPaginate]); // @ts-ignore
    var _insert = props.insert;
    var insert = useCallback(function (input) { return __awaiter(_this, void 0, void 0, function () { var result; return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!_insert)
                    return [2 /*return*/];
                return [4 /*yield*/, _insert(input)];
            case 1:
                result = _a.sent();
                setInserted(function (old) { return __spreadArray([result], old, true); });
                return [2 /*return*/, result];
        }
    }); }); }, [_insert]);
    if (!_insert) {
        insert = undefined;
    } // @ts-ignore
    var updater = props.update;
    var rows = ((_list$result = list.result) === null || _list$result === void 0 ? void 0 : _list$result.data) || blankArray;
    rows = useMemo(function () { return __spreadArray(__spreadArray([], inserted, true), rows, true); }, [inserted, rows]);
    var ctx = useContext(TableContext);
    var register = ctx.registerTable;
    var listReloader = list.reload;
    var fetcher = props.fetcher;
    var columns = props.cols;
    var editable = props.editable;
    useEffect(function () { register({ reload: function () { listReloader(); setInserted([]); }, download: function (filename) {
            return __awaiter(this, void 0, void 0, function () { var list, expected, result; return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        list = [];
                        expected = 0;
                        _a.label = 1;
                    case 1: return [4 /*yield*/, fetcher({ search: "", orderBy: orderBy, orderByDirection: orderByDirection, parentId: parentId, filter: encodeFilter(filter), page: 0, pageSize: 0 })];
                    case 2:
                        result = _a.sent();
                        list.push.apply(list, result.data);
                        expected = result.totalCount;
                        _a.label = 3;
                    case 3:
                        if (list.length < expected) return [3 /*break*/, 1];
                        _a.label = 4;
                    case 4:
                        downloadResultAsFile(filename, list, columns, editable);
                        return [2 /*return*/];
                }
            }); });
        } }); }, [register, filter, listReloader, fetcher, orderBy, orderByDirection, parentId, columns, editable, rows]); // eslint-disable-next-line react-hooks/exhaustive-deps
    var navigateTo = useMemo(function () { return props.navigateTo; }, []); // eslint-disable-next-line react-hooks/exhaustive-deps
    var onRowClick = useMemo(function () { return props.onRowClick; }, []);
    return /*#__PURE__*/ _jsx(TableViewData, { totalCount: ((_list$result2 = list.result) === null || _list$result2 === void 0 ? void 0 : _list$result2.totalCount) || 0, columns: props.cols, navigateTo: navigateTo, onRowClick: onRowClick, rowIsLocked: props.editable ? props.rowIsLocked : undefined, rows: rows, insert: insert, update: updater, loading: list.loading, error: list.error, onOrderByChange: props.lockOrderBy ? function () { } : orderByChange, orderBy: orderBy, editable: props.editable, orderByDirection: orderByDirection, onSelectionChanged: props.onSelectionChange, onPageChange: setPage, rowsPerPage: pageSize, page: page, noPaginate: props.noPaginate });
}
function extractTextFromReact(obj) { if (obj === undefined || obj === null)
    return ""; if (typeof obj === "string")
    return obj; if (typeof obj === "object" && "props" in obj) {
    if (obj.props.children instanceof Array) {
        return obj.props.children.map(extractTextFromReact).join("");
    }
    return extractTextFromReact(obj.props.children);
} return obj.toString(); }
function toCSV(data) { var rows = data.map(function (row) { return row.map(function (value) { if (/[,\r\n]/.exec(value) !== null) {
    return '"' + value.replace(/"/g, '""') + '"';
} return value; }).join(","); }); return rows.join("\r\n"); }
export function downloadResultAsFile(filename, list, columns, editable) { var renderer = []; if (columnsAreEditable(columns, editable)) {
    renderer = columns.filter(function (c) { return c.actions !== true; }).map(function (c) { if (c.key !== undefined) {
        var key_1 = c.key;
        return { name: c.name, lookup: function (row) { return valueToString(row, row[key_1], c); } };
    } switch (c.type) {
        case "computed": return { name: c.name, lookup: function (row) { return extractTextFromReact(c.selector(row)); } };
        case "select-entity-from-list": return { name: c.name, lookup: function (row) { return row[c.displayKey]; } };
        default: return { name: c.name, lookup: function (row) { return ""; } };
    } });
}
else if (isSubCols(columns)) {
    renderer = columns.filter(function (c) { return c.actions !== true; }).map(function (c) { return ({ name: c.name, lookup: function (row) { return extractTextFromReact("selector" in c ? c.selector(row) : row[c.key]); } }); });
}
else {
    renderer = columns.filter(function (c) { return c.actions !== true; }).map(function (c) { return ({ name: c.name, lookup: function (row) { return extractTextFromReact(c.selector(row)); } }); });
} downloadCSV(filename, __spreadArray([renderer.map(function (col) { return col.name; })], list.map(function (row) { return renderer.map(function (col) { return col.lookup(row); }); }), true)); }
export function downloadCSV(filename, input) {
    var csv = toCSV(input);
    var blob = new Blob([csv], { type: "text/csv" });
    var fileURL = window.URL.createObjectURL(blob);
    var link = document.createElement("a");
    link.href = fileURL;
    link.download = filename;
    link.click();
    setTimeout(function () { window.URL.revokeObjectURL(fileURL); }, 250); // firefox requires timeout
}
